import styled from 'styled-components';
import {lighten, transparentize} from 'polished';
import {transition} from 'helpers/css';

export const BlockLabel = styled.div`
  margin-bottom: 20px;
  font-size: 14px;
  font-weight: 500;
  line-height: 18px;
  letter-spacing: 0.04em;
  text-transform: uppercase;
  color: ${({theme}) => `
    ${theme.colors.primaryLight}
  `};

  @media screen and (max-width: 640px) {
    font-size: 12px;
    line-height: 16px;
    margin-bottom: 10px;
  }
`;

export const BlockTitle = styled.div`
  font-size: 36px;
  font-weight: 700;
  line-height: 43px;
  max-width: 496px;

  @media screen and (max-width: 640px) {
    font-size: 24px;
    line-height: 29px;
  }
`;

export const Column = styled.div`
  display: flex;
  flex-direction: column;
`;

export const OldPrice = styled.div`
  font-size: 14px;
  font-weight: 500;
  line-height: 18px;
  text-decoration: line-through;
  color: ${({theme}) => `
    ${transparentize(.8, theme.colors.white)};
  `};
`;

export const SeatsNumber = styled.div`
  margin-top: 4px;

  font-size: 14px;
  font-weight: 500;
  line-height: 18px;
  
  color: ${({theme}) => `
    ${transparentize(.2, theme.colors.white)};
  `};
`;

export const ButtonRounded = styled.div`
  padding: 19px 24px;
  border-radius: 100px;
  background-color: ${({theme}) => theme.colors.primary};
  color: white;
  cursor: pointer;
  
  ${transition()}
  
  &:hover {
    background-color: ${({theme}) => lighten(.02, theme.colors.primary)};
  }
`;
